'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _errors = require('./errors.css');

var _errors2 = _interopRequireDefault(_errors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error404 = function Error404() {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'p',
      null,
      '404! Not found'
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/' },
        'Take me home'
      )
    )
  );
};

exports.default = Error404;


//////////////////
// WEBPACK FOOTER
// ./src/components/Errors/Error404.js
// module id = 322
// module chunks = 1